import { render, staticRenderFns } from "./ExamSubject.vue?vue&type=template&id=be63bcec&scoped=true&lang=html&"
import script from "./ExamSubject.vue?vue&type=script&lang=js&"
export * from "./ExamSubject.vue?vue&type=script&lang=js&"
import style0 from "./ExamSubject.vue?vue&type=style&index=0&id=be63bcec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be63bcec",
  null
  
)

export default component.exports